import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query'
import { getDisciplines } from 'data/Querys';
import { useNavigate } from 'react-router-dom';
import { getURL } from 'helpers/utils';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
//import { NavDropdown } from 'react-bootstrap'


export default function DisciplineMenu() {
    let params = useUrlFriendlyToParameters()
    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }


    //Load data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['CC_Disciplines', paramsURL['mirs_competition'], paramsURL['mirs_language']],
            queryFn: getDisciplines,
            //refetchInterval: 30000,
            refetchInterval: 0,
            refetchIntervalInBackground: true,
            //cacheTime: 3000000,
            staleTime: Infinity,
            retry: false,
            suspense: false,
            notifyOnChangeProps: ['data', 'error'],
        });


    const options = data?.disciplines?.filter(item => item?.isSport && item?.scheduled)?.map((item, index) => {
        return (
            <ItemDiscipline key={"Selector-Discipline-" + item.code} code={item.code} description={item.description} />
        )
    })

    return (
        <>
            <div id="discipline-menu" className={"discipline-menu"} >
                <div className="discipline-grid">
                    {options}
                </div>
            </div>
        </>
    );
};




const ItemDiscipline = (props) => {
    let params = useUrlFriendlyToParameters();
    let competition = params.mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };
    //Click to New URL 
    const navigate = useNavigate();
    const handleOnChange = useCallback((key) => {
        //setValue(key);
        params["mirs_discipline"] = key
        params["mirs_event"] = undefined
        params["mirs_date"] = undefined

        const url = getURL(params, 'schedule')
        navigate(url, { replace: true })
    }, [navigate]);




    return (
        <div className="itemDiscipline justify-content-left" onClick={() => handleOnChange(props.code)}>
            <div className="discipline-context">
                {showImage ? (
                    <img aria-hidden="true"
                        src={`/assets/images/sports/${competition}/Dark/${props.code}.png`}
                        alt={props.description}
                        onError={hideImg} />
                ) : (
                    props.code
                )}
            </div>
            {props.description}
            {/*{props.code && <> - {props.code}</>}*/}
        </div>
    )
};